// ** Custom Components
import React, { useEffect, useState, useRef } from "react";
import Box from "../Box";
import Container from "../Container";
import Heading from "../Heading";
import Text from "../Text";
import PaymentBreakdown from "./PaymentBreakdown";
//import Calexcel from './Calexcel';

// ** Utils
import { serializers } from "../Serializers";

// ** 3rd Party Library
import { PortableText } from "@portabletext/react";
import PieChart from "./PieChart";

import "./layoutCal.css";

const SectionCalculator = ({ section }: any) => {
  const { title, subTitle, _rawContent: content } = section;
  const [propertyVal, setPropertyVal] = useState(500000);
  const [tab2PropertyVal, setTab2PropertyVal] = useState(700000);
  const [mortgageInsurance, setMortgageInsurance] = useState(0);
  const [tab2MortgageInsurance, setTab2MortgageInsurance] = useState(0);
  const [interestRate, setInterestRate] = useState(5);
  const [tab2InterestRate, setTab2InterestRate] = useState(5);
  const [amortization, setAmortization] = useState(25);
  const [tab2Amortization, setTab2Amortization] = useState(25);
  const [mortgageTerm, setMortgageTerm] = useState(5);
  const [tab2MortgageTerm, setTab2MortgageTerm] = useState(5);
  const [monthlyPayment, setMonthlyPayment] = useState(0);
  const [tab2MonthlyPayment, setTab2MonthlyPayment] = useState(0);
  const [loanAmount, setLoanAmount] = useState(0);
  const [tab2LoanAmount, setTab2LoanAmount] = useState(0);
  const [paymentFreq, setPaymentFreq] = useState(12);
  const [tab2PaymentFreq, setTab2PaymentFreq] = useState(12);
  const [selectProvince, setProvince] = useState("on");
  const [tab2SelectProvince, setTab2Province] = useState("on");
  const [show30, setShow30] = useState(true);
  const [showTab230, setShow30Tab2] = useState(true);
  const [showError, setShowError] = useState(false);
  const [downIntShowError, setDownIntShowError] = useState(false);
  const [tab2DownIntShowError, setTab2DownIntShowError] = useState(false);
  const [showCheck, setShowCheck] = useState(true);
  const [showCheckTab2, setShowCheckTab2] = useState(true);
  const [btnText, setBtnText] = useState(true);
  const [activeTab, setActiveTab] = useState("tab1");

  const [downPayment, setDownPayment] = useState(50000);
  const [tab2DownPayment, setTab2DownPayment] = useState(70000);
  const [downInterest, setDownInterest] = useState(10);
  const [tab2DownInterest, setTab2DownInterest] = useState(10);
  const [paymentFreqOption, setPaymentFreqOption] = useState("Monthly");
  const [tab2PaymentFreqOption, setTab2PaymentFreqOption] = useState("Monthly");

  const [showMortgageInsurance, setShowMortageInsyrance] = useState(true);

  const pdfRef = useRef<HTMLDivElement>(null);

  const handleBtnText = () => {
    setBtnText(!btnText);
    if (btnText === false) {
      setActiveTab("tab1");
    }
  };

  const handleTabClick = (tab: string, e: any) => {
    e.preventDefault();
    setActiveTab(tab);
  };

  const formatWithCommas = (value: number) => {
    return Number(value).toLocaleString();
  };

  const handlePropertyVal = (tab: string, e: any) => {
    const inputValue = e.target.value.replace(/\D/g, "");
    const value = inputValue ? parseFloat(inputValue) : 0;

    if (value <= 100000000) {
      if (tab === "tab1") {
        setPropertyVal(value);
        if (value === 0) {
          setDownPayment(0);
          setDownInterest(0);
        }
      } else {
        setTab2PropertyVal(value);
        if (value === 0) {
          setTab2DownPayment(0);
          setTab2DownInterest(0);
        }
      }
      setShowError(false);
    } else {
      setShowError(true);
    }
  };

  const handleDownpaymentVal = (tab: string, e: any) => {
    if (tab === "tab1") {
      setDownPayment(e.target.value.replace(/\D/g, "") || 0);
    } else {
      setTab2DownPayment(e.target.value.replace(/\D/g, "") || 0);
    }
  };

  const handleAmortization = (tab: string, e: any) => {
    if (tab === "tab1") {
      setAmortization(e.target.value);
    } else {
      setTab2Amortization(e.target.value);
    }
  };

  const handleProvince = (tab: string, e: any) => {
    if (tab === "tab1") {
      setProvince(e.target.value);
      if (e.target.value === "on") {
        setShowCheck(true);
      } else {
        setShowCheck(false);
      }
    } else {
      setTab2Province(e.target.value);
      if (e.target.value === "on") {
        setShowCheckTab2(true);
      } else {
        setShowCheckTab2(false);
      }
    }
  };

  const handlePaymentFreq = (tab: string, e: any) => {
    if (tab === "tab1") {
      setPaymentFreq(e.target.value);
    } else {
      setTab2PaymentFreq(e.target.value);
    }
  };

  const handleMortgageTerm = (tab: string, e: any) => {
    if (tab === "tab1") {
      setMortgageTerm(e.target.value);
    } else {
      setTab2MortgageTerm(e.target.value);
    }
  };

  const handleInterestRate = (tab: string, e: any) => {
    const rateInt = e.target.value.replace(/[^0-9.]/g, "") || 0;
    const parts = rateInt.toString().split(".");
    if (
      parts[0] <= 100 &&
      (parts.length === 1 || (parts.length === 2 && parts[1].length <= 2))
    ) {
      if (parts[0] <= 100) {
        if (tab === "tab1") {
          setInterestRate(rateInt);
        } else {
          setTab2InterestRate(rateInt);
        }
      }
    }
  };

  const handleDownInterest = (tab: string, e: any) => {
    const downInt = e.target.value.replace(/[^0-9.]/g, "") || 0;
    const parts = downInt.toString().split(".");
    if (
      parts[0] <= 100 &&
      (parts.length === 1 || (parts.length === 2 && parts[1].length <= 2))
    ) {
      if (parts[0] <= 100) {
        if (tab === "tab1") {
          setDownInterest(downInt);
          const newDownPayment = (propertyVal * downInt) / 100;
          setDownPayment(newDownPayment);
          if (downInt >= 20) {
            setShowMortageInsyrance(false);
          } else {
            setShowMortageInsyrance(true);
          }
        } else {
          setTab2DownInterest(downInt);
          const newDownPayment = (tab2PropertyVal * downInt) / 100;
          setTab2DownPayment(newDownPayment);
        }
      }
    }
  };

  const handleKeyDown = (identifier: string) => (e: any) => {
    if (e.key === "Tab") return;

    if (e.key === "Backspace" || e.key === "Delete") {
      const input = e.target;
      const value = input.value;

      if (propertyVal === 0) {
        setDownPayment(0);
        setDownInterest(0);
      }

      if (value.endsWith("%")) {
        e.preventDefault();
        input.value = value.slice(0, -1);
        if (identifier === "rateIntrest") {
          setInterestRate(parseFloat(input.value.replace("%", "")) || 0);
        }
        if (identifier === "downIntrest") {
          setDownInterest(parseFloat(input.value.replace("%", "")) || 0);
        }
      }
    } else {
      const isNumeric = /^\d*\.?\d*$/.test(e.key);
      const isSpecialKey = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        ".",
        "Tab",
      ].includes(e.key);
      if (!isNumeric && !isSpecialKey) {
        e.preventDefault();
      }
    }
  };

  const handlePaste = (tab: string, e: any) => {
    e.preventDefault();

    const paste =
      (e.clipboardData || window.clipboardData)?.getData("text") || 0;
    const numericValue = paste.split(".")[0].replace(/\D/g, "");

    if (numericValue) {
      if (tab === "tab1") {
        setPropertyVal(numericValue);
      } else {
        setTab2PropertyVal(numericValue);
      }

      setShowError(false);
    } else {
      setShowError(true);
    }
  };

  useEffect(() => {
    if (downInterest >= 5 || downInterest == 0) {
      setDownIntShowError(false);
    } else {
      setDownIntShowError(true);
    }
  }, [downPayment, downInterest]);

  useEffect(() => {
    if (tab2DownInterest >= 5 || tab2DownInterest == 0) {
      setTab2DownIntShowError(false);
    } else {
      setTab2DownIntShowError(true);
    }
  }, [tab2DownPayment, tab2DownInterest]);

  useEffect(() => {
    const newDownPayment = (propertyVal * downInterest) / 100;
    setDownPayment(newDownPayment);
  }, [propertyVal]);

  useEffect(() => {
    const newDownPayment = (tab2PropertyVal * tab2DownInterest) / 100;
    setTab2DownPayment(newDownPayment);
  }, [tab2PropertyVal]);

  useEffect(() => {
    const newIntrest = (downPayment / propertyVal) * 100;
    setDownInterest(parseFloat(newIntrest.toFixed(2)));
  }, [downPayment]);

  useEffect(() => {
    const tab2NewIntrest = (tab2DownPayment / tab2PropertyVal) * 100;
    setTab2DownInterest(parseFloat(tab2NewIntrest.toFixed(2)));
  }, [tab2DownPayment]);

  useEffect(() => {
    const mortgageAmount = propertyVal - downPayment;
    if (downInterest >= 1 && downInterest < 20) {
      let mortInsurance = 0;
      if (downInterest >= 0 && downInterest < 10) {
        mortInsurance = (mortgageAmount * 4) / 100;
      } else if (downInterest >= 10 && downInterest < 15) {
        mortInsurance = (mortgageAmount * 3.1) / 100;
      } else {
        mortInsurance = (mortgageAmount * 2.8) / 100;
      }
      setLoanAmount(mortgageAmount + mortInsurance);
      setShow30(true);
      if (paymentFreq == 12) {
        setMortgageInsurance(
          getMonthlyPayment(mortInsurance, interestRate, amortization)
        );
      } else {
        setMortgageInsurance(
          getPaymentFreqVal(
            mortInsurance,
            interestRate,
            amortization,
            paymentFreq
          )
        );
      }
    } else {
      setShow30(false);
      if (paymentFreq == 12) {
        setLoanAmount(mortgageAmount);
        setMortgageInsurance(getMonthlyPayment(0, interestRate, amortization));
      } else {
        setLoanAmount(mortgageAmount);
        setMortgageInsurance(
          getPaymentFreqVal(0, interestRate, amortization, paymentFreq)
        );
      }
    }
    if (paymentFreq == 12) {
      setMonthlyPayment(
        getMonthlyPayment(mortgageAmount, interestRate, amortization)
      );
      setPaymentFreqOption("Monthly");
    } else {
      setMonthlyPayment(
        getPaymentFreqVal(
          mortgageAmount,
          interestRate,
          amortization,
          paymentFreq
        )
      );
      if (paymentFreq == 24) {
        setPaymentFreqOption("Semi-Monthly");
      } else if (paymentFreq == 26) {
        setPaymentFreqOption("Bi-Weekly");
      } else {
        setPaymentFreqOption("Weekly");
      }
    }
  }, [
    propertyVal,
    interestRate,
    amortization,
    downPayment,
    downInterest,
    paymentFreq,
  ]);

  useEffect(() => {
    const mortgageAmount = tab2PropertyVal - tab2DownPayment;
    if (tab2DownInterest >= 1 && tab2DownInterest < 20) {
      let mortInsurance = 0;
      if (tab2DownInterest >= 0 && tab2DownInterest < 10) {
        mortInsurance = (mortgageAmount * 4) / 100;
      } else if (tab2DownInterest >= 10 && tab2DownInterest < 15) {
        mortInsurance = (mortgageAmount * 3.1) / 100;
      } else {
        mortInsurance = (mortgageAmount * 2.8) / 100;
      }
      setTab2LoanAmount(mortgageAmount + mortInsurance);
      setShow30Tab2(true);
      if (tab2PaymentFreq == 12) {
        setTab2MortgageInsurance(
          getMonthlyPayment(mortInsurance, tab2InterestRate, tab2Amortization)
        );
      } else {
        setTab2MortgageInsurance(
          getPaymentFreqVal(
            mortInsurance,
            tab2InterestRate,
            tab2Amortization,
            tab2PaymentFreq
          )
        );
      }
    } else {
      setShow30Tab2(false);
      if (tab2PaymentFreq == 12) {
        setTab2LoanAmount(mortgageAmount);
        setTab2MortgageInsurance(
          getMonthlyPayment(0, tab2InterestRate, tab2Amortization)
        );
      } else {
        setTab2LoanAmount(mortgageAmount);
        setTab2MortgageInsurance(
          getPaymentFreqVal(
            0,
            tab2InterestRate,
            tab2Amortization,
            tab2PaymentFreq
          )
        );
      }
    }
    if (tab2PaymentFreq == 12) {
      setTab2MonthlyPayment(
        getMonthlyPayment(mortgageAmount, tab2InterestRate, tab2Amortization)
      );
      setTab2PaymentFreqOption("Monthly");
    } else {
      setTab2MonthlyPayment(
        getPaymentFreqVal(
          mortgageAmount,
          tab2InterestRate,
          tab2Amortization,
          tab2PaymentFreq
        )
      );
      if (tab2PaymentFreq == 24) {
        setTab2PaymentFreqOption("Semi-Monthly");
      } else if (tab2PaymentFreq == 26) {
        setTab2PaymentFreqOption("Bi-Weekly");
      } else {
        setTab2PaymentFreqOption("Weekly");
      }
    }
  }, [
    tab2PropertyVal,
    tab2InterestRate,
    tab2Amortization,
    tab2DownPayment,
    tab2DownInterest,
    tab2PaymentFreq,
  ]);

  const getMonthlyPayment = (
    mortgageAmount: number,
    annualInterestRate: number,
    amortization: number
  ) => {
    const annualInterestRateDecimal = annualInterestRate / 100;
    const monthlyInterestRate =
      Math.pow(1 + annualInterestRateDecimal / 2, 1 / 6) - 1;
    const totalPayments = amortization * 12;
    const monthlyPayment =
      mortgageAmount /
      ((1 - Math.pow(1 + monthlyInterestRate, -totalPayments)) /
        monthlyInterestRate);
    return monthlyPayment;
  };

  const getPaymentFreqVal = (
    mortgageAmount: number,
    annualInterestRate: number,
    amortization: number,
    payFreq: number
  ) => {
    const annuallyIntRate = annualInterestRate / 200;
    const effectiveAnnualIntRate = Math.pow(1 + annuallyIntRate, 2) - 1;
    const weeklyInterestRate =
      Math.pow(1 + effectiveAnnualIntRate, 1 / Number(payFreq)) - 1;
    const totalPayments = amortization * payFreq;
    const discountFactor =
      (Math.pow(1 + weeklyInterestRate, totalPayments) - 1) /
      (weeklyInterestRate * Math.pow(1 + weeklyInterestRate, totalPayments));
    const weeklyPayment = mortgageAmount / discountFactor;
    return weeklyPayment;
  };

  // const formatNumberWithCommas = (number:number) => {
  //   return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };

  return (
    <Container
      className="flex flex-col w-full gap-10 mt-10 md:mt-14"
      fullWidthOnMobile={false}
      constrainedToBreakPoint
    >
      <Box className="w-full ">
        <Heading as="h1" className="text-blue-500 mb-8 text-left">
          {title}
        </Heading>
        <Text
          variant="large"
          className="text-blue-500 !text-base mb-8 text-left"
        >
          {subTitle}
        </Text>
      </Box>
      <section className="mortage_section">
        <div className="p-5">
          <div className="grid grid-cols-3 gap-4 grid-flow-row container xl mx-auto">
            <div className="p-5 text-left bg-white row-start-1 row-end-4 border-solid border-2 border-gray-300 sm:rounded-lg">
              <h4 className="mb-4 text-xl font-bold blueColor flex justify-between">
                Mortgage {btnText ? "Details" : "Comparison"}{" "}
                <button
                  className="btn font-bold uppercase"
                  id="myButton"
                  onClick={handleBtnText}
                >
                  {btnText ? (
                    <svg>
                      <path d="M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
                    </svg>
                  ) : (
                    <svg>
                      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                    </svg>
                  )}
                  <span className="button-text">
                    {btnText ? "Compare" : "Exit"}
                  </span>
                </button>
              </h4>
              <nav
                id="tabs"
                className={`flex justify-between border-b mb-3 uppercase font-medium ${
                  btnText ? "hidden" : "active"
                }`}
              >
                <li className={activeTab === "tab1" ? "active" : ""}>
                  <a href="#tab1" onClick={(e) => handleTabClick("tab1", e)}>
                    Option 1
                  </a>
                </li>
                <li className={activeTab === "tab2" ? "active" : ""}>
                  <a href="#tab2" onClick={(e) => handleTabClick("tab2", e)}>
                    Option 2
                  </a>
                </li>
              </nav>
              <section id="tab-contents">
                <div
                  id="tab1"
                  className={`tab-contents ${
                    activeTab === "tab1" ? "active" : "hidden"
                  }`}
                >
                  <form>
                    <div className="mb-6 relative">
                      <input
                        type="text"
                        id="propertyVal"
                        className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        placeholder=" "
                        required
                        value={"$" + formatWithCommas(propertyVal)}
                        onChange={(e) => handlePropertyVal("tab1", e)}
                        onKeyDown={handleKeyDown("PropertyVal")}
                        onPaste={(e) => handlePaste("tab1", e)}
                      />
                      <label
                        htmlFor="propertyVal"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Property Value
                      </label>
                      {showError && (
                        <span style={{ color: "#ff0000" }}>
                          You can not enter more than 100 M
                        </span>
                      )}
                    </div>
                    <div className="grid gap-5 mb-6 md:grid-cols-2">
                      <div className="relative">
                        <input
                          type="text"
                          id="downPayment"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          placeholder=" "
                          required
                          value={formatWithCommas(Math.round(downPayment))}
                          onChange={(e) => handleDownpaymentVal("tab1", e)}
                          onKeyDown={handleKeyDown("DownPaymentVal")}
                        />
                        <label
                          htmlFor="downPayment"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Down Payment
                        </label>
                        {downIntShowError && (
                          <span style={{ color: "#ff0000" }}>
                            Please enter a down payment of at least 5%
                          </span>
                        )}
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          id="downInt"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          placeholder=" "
                          required
                          value={downInterest === 0 ? "" : downInterest + "%"}
                          onChange={(e) => handleDownInterest("tab1", e)}
                          onKeyDown={handleKeyDown("downIntrest")}
                        />
                      </div>
                    </div>
                    <div className="mb-6 relative">
                      <input
                        type="text"
                        id="rateInt"
                        className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        placeholder=" "
                        required
                        value={interestRate === 0 ? "" : interestRate + "%"}
                        onChange={(e) => handleInterestRate("tab1", e)}
                        onKeyDown={handleKeyDown("rateIntrest")}
                      />
                      <label
                        htmlFor="rateInt"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Interest Rate
                      </label>
                    </div>
                    <div className="grid gap-5 mb-6 md:grid-cols-2">
                      <div className="relative">
                        <select
                          id="mortYears"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          value={mortgageTerm}
                          onChange={(e) => handleMortgageTerm("tab1", e)}
                        >
                          <option value={1}>1 Years</option>
                          <option value={2}>2 Years</option>
                          <option value={3}>3 Years</option>
                          <option value={4}>4 Years</option>
                          <option value={5} selected>
                            5 Years
                          </option>
                          <option value={6}>6 Years</option>
                          <option value={7}>7 Years</option>
                          <option value={8}>8 Years</option>
                          <option value={9}>9 Years</option>
                          <option value={10}>10 Years</option>
                        </select>
                        <label
                          htmlFor="mortYears"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Mortgage Term
                        </label>
                        {/* <div className="relative flex flex-col items-center group">
                                    <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                                    </svg>
                                    <div className="absolute bottom-0 flex flex-col items-center hidden mb-5 group-hover:flex">
                                    <span className="relative rounded-md z-10 p-4 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg">A top aligned tooltip. That has enough text to be multi-line!<p className="pt-4 pb-4">Just check it out!</p></span>
                                    <div className="w-3 h-3 -mt-2 rotate-45 bg-black"></div>
                                    </div>
                                </div> */}
                      </div>
                      <div className="relative">
                        <select
                          id="fixVar"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        >
                          <option selected>Fixed</option>
                          <option value="DE">Variable</option>
                        </select>
                        <label
                          htmlFor="fixVar"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Rate Type
                        </label>
                      </div>
                      <div className="relative">
                        <select
                          id="amortYears"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          value={amortization}
                          onChange={(e) => handleAmortization("tab1", e)}
                        >
                          <option value={5}>5 Years</option>
                          <option value={10}>10 Years</option>
                          <option value={15}>15 Years</option>
                          <option value={20}>20 Years</option>
                          <option value={25}>25 Years</option>
                          <option value={30}>30 Years</option>
                        </select>
                        <label
                          htmlFor="amortYears"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Amortization
                        </label>
                      </div>
                      <div className="relative">
                        <select
                          id="payFreq"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          value={paymentFreq}
                          onChange={(e) => handlePaymentFreq("tab1", e)}
                        >
                          <option value={52}>Weekly (52x per year)</option>
                          <option value={26}>Bi-Weekly (26x per year)</option>
                          <option value={12} selected>
                            Monthly (12x per year)
                          </option>
                          <option value={24}>
                            Semi-Monthly (24x per year)
                          </option>
                        </select>
                        <label
                          htmlFor="payFreq"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Payment Frequency
                        </label>
                      </div>
                    </div>
                    <h4 className="mb-4 text-sm font-bold ">
                      Location Details
                    </h4>
                    <div className="mb-6 relative">
                      <select
                        id="countries"
                        className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        value={selectProvince}
                        onChange={(e) => handleProvince("tab1", e)}
                      >
                        <option value="al">Alberta</option>
                        <option value="bc">British Columbia</option>
                        <option value="mt">Manitoba</option>
                        <option value="nb">New Brunswick</option>
                        <option value="nl">Newfoundland and Labrador</option>
                        <option value="nt">Northwest Territories</option>
                        <option value="ns">Nova Scotia</option>
                        <option value="nv">Nunavut</option>
                        <option value="on" selected>
                          Ontario
                        </option>
                        <option value="pe">Prince Edward Island</option>
                        <option value="qu">Quebec</option>
                        <option value="sc">Saskatchewan</option>
                        <option value="yu">Yukon</option>
                      </select>
                      <label
                        htmlFor="countries"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Province
                      </label>
                    </div>
                    {showCheck && (
                      <div className="flex items-start mb-6">
                        <div className="flex items-center h-5 relative">
                          <input
                            id="remember"
                            type="checkbox"
                            value=""
                            className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                            required
                          />
                        </div>
                        <label
                          htmlFor="remember"
                          className="ms-2 mx-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          City of Toronto
                        </label>
                      </div>
                    )}
                  </form>
                </div>
                <div
                  id="tab2"
                  className={`tab-contents ${
                    activeTab === "tab2" ? "active" : "hidden"
                  }`}
                >
                  <form>
                    <div className="mb-6 relative">
                      <input
                        type="text"
                        id="new_propertyVal"
                        className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        placeholder=" "
                        required
                        value={"$" + formatWithCommas(tab2PropertyVal)}
                        onChange={(e) => handlePropertyVal("tab2", e)}
                        onKeyDown={handleKeyDown("PropertyVal")}
                        onPaste={(e) => handlePaste("tab2", e)}
                      />
                      <label
                        htmlFor="new_propertyVal"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Property Value
                      </label>
                      {showError && (
                        <span style={{ color: "#ff0000" }}>
                          You can not enter more than 100 M
                        </span>
                      )}
                    </div>
                    <div className="grid gap-5 mb-6 md:grid-cols-2">
                      <div className="relative">
                        <input
                          type="text"
                          id="new_downPay"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          placeholder=" "
                          required
                          value={formatWithCommas(Math.round(tab2DownPayment))}
                          onChange={(e) => handleDownpaymentVal("tab2", e)}
                          onKeyDown={handleKeyDown("DownPaymentVal")}
                        />
                        <label
                          htmlFor="new_downPay"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Down Payment
                        </label>
                        {tab2DownIntShowError && (
                          <span style={{ color: "#ff0000" }}>
                            Please enter a down payment of at least 5%
                          </span>
                        )}
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          id="new_down_int"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          placeholder=" "
                          required
                          value={
                            tab2DownInterest === 0 ? "" : tab2DownInterest + "%"
                          }
                          onChange={(e) => handleDownInterest("tab2", e)}
                          onKeyDown={handleKeyDown("downIntrest")}
                        />
                      </div>
                    </div>
                    <div className="mb-6 relative">
                      <input
                        type="text"
                        id="new_Int_rate"
                        className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        placeholder=" "
                        required
                        value={
                          tab2InterestRate === 0 ? "" : tab2InterestRate + "%"
                        }
                        onChange={(e) => handleInterestRate("tab2", e)}
                        onKeyDown={handleKeyDown("rateIntrest")}
                      />
                      <label
                        htmlFor="new_Int_rate"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Interest Rate
                      </label>
                    </div>
                    <div className="grid gap-5 mb-6 md:grid-cols-2">
                      <div className="relative">
                        <select
                          id="new_mortYears"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          value={tab2MortgageTerm}
                          onChange={(e) => handleMortgageTerm("tab2", e)}
                        >
                          <option value={1}>1 Years</option>
                          <option value={2}>2 Years</option>
                          <option value={3}>3 Years</option>
                          <option value={4}>4 Years</option>
                          <option value={5} selected>
                            5 Years
                          </option>
                          <option value={6}>6 Years</option>
                          <option value={7}>7 Years</option>
                          <option value={8}>8 Years</option>
                          <option value={9}>9 Years</option>
                          <option value={10}>10 Years</option>
                        </select>
                        <label
                          htmlFor="new_mortYears"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Mortgage Term
                        </label>
                      </div>
                      <div className="relative">
                        <select
                          id="new_fixVar"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        >
                          <option selected>Fixed</option>
                          <option value="DE">Variable</option>
                        </select>
                        <label
                          htmlFor="new_fixVar"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Rate Type
                        </label>
                      </div>
                      <div className="relative">
                        <select
                          id="new_amorVal"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          value={tab2Amortization}
                          onChange={(e) => handleAmortization("tab2", e)}
                        >
                          <option value={5}>5 Years</option>
                          <option value={10}>10 Years</option>
                          <option value={15}>15 Years</option>
                          <option value={20}>20 Years</option>
                          <option value={25}>25 Years</option>
                          <option value={30}>30 Years</option>
                        </select>
                        <label
                          htmlFor="new_amorVal"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Amortization
                        </label>
                      </div>
                      <div className="relative">
                        <select
                          id="new_payFreq"
                          className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                          value={tab2PaymentFreq}
                          onChange={(e) => handlePaymentFreq("tab2", e)}
                        >
                          <option value={52}>Weekly (52x per year)</option>
                          <option value={26}>Bi-Weekly (26x per year)</option>
                          <option value={12} selected>
                            Monthly (12x per year)
                          </option>
                          <option value={24}>
                            Semi-Monthly (24x per year)
                          </option>
                        </select>
                        <label
                          htmlFor="new_payFreq"
                          className="block mb-2 text-sm font-medium text-gray-900"
                        >
                          Payment Frequency
                        </label>
                      </div>
                    </div>
                    <h4 className="mb-4 text-sm font-bold ">
                      Location Details
                    </h4>
                    <div className="mb-6 relative">
                      <select
                        id="new_countries"
                        className="p-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        value={tab2SelectProvince}
                        onChange={(e) => handleProvince("tab2", e)}
                      >
                        <option value="al">Alberta</option>
                        <option value="bc">British Columbia</option>
                        <option value="mt">Manitoba</option>
                        <option value="nb">New Brunswick</option>
                        <option value="nl">Newfoundland and Labrador</option>
                        <option value="nt">Northwest Territories</option>
                        <option value="ns">Nova Scotia</option>
                        <option value="nv">Nunavut</option>
                        <option value="on" selected>
                          Ontario
                        </option>
                        <option value="pe">Prince Edward Island</option>
                        <option value="qu">Quebec</option>
                        <option value="sc">Saskatchewan</option>
                        <option value="yu">Yukon</option>
                      </select>
                      <label
                        htmlFor="new_countries"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Province
                      </label>
                    </div>
                    {showCheckTab2 && (
                      <div className="flex items-start mb-6">
                        <div className="flex items-center h-5 relative">
                          <input
                            id="new_remember"
                            type="checkbox"
                            value=""
                            className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                            required
                          />
                        </div>
                        <label
                          htmlFor="new_remember"
                          className="ms-2 mx-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          City of Toronto
                        </label>
                      </div>
                    )}
                  </form>
                </div>
              </section>
            </div>
            {btnText ? (
              <>
                <div
                  className="p-5 text-left bg-white col-start-2 col-end-4"
                  ref={pdfRef}
                >
                  <h1 className="mb-12 text-4xl font-bold blueColor">
                    Mortgage Summary
                  </h1>
                  <h5 className="mb-1 text-xl font-bold blueColor">
                    Estimated Payment
                  </h5>
                  <p className="text-sm font-light">
                    The following items show your expected payment schedule over
                    the full amortization period.
                  </p>
                  <div className="grid gap-12 mb-6 md:grid-cols-2">
                    <div className="flex flex-col items-center justify-center pb-3">
                      <div className="flex items-center">
                        <PieChart
                          piedata={[
                            {
                              label: "Principal & Interest",
                              value: Math.round(monthlyPayment),
                              color: "#264283",
                            },
                            {
                              label: "Mortgage Insurance",
                              value: Math.round(mortgageInsurance),
                              color: "#DB9247",
                            },
                          ]}
                        />
                        <div className="text-sm font-bold text-center">
                          <h5 className="mb-6 text-6xl font-bold blueColor">
                            {"$" +
                              formatWithCommas(
                                Math.round(monthlyPayment + mortgageInsurance)
                              )}
                          </h5>
                          <p className="mb-6 text-sm font-light font-normal">
                            {paymentFreqOption} Payment
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col justify-center mt-6">
                      <div className="grid gap-5 md:grid-cols-2 border-b pb-3 mb-3">
                        <div className="font-normal">
                          <span
                            className="colored_circle"
                            style={{ backgroundColor: "#264283" }}
                          />{" "}
                          Principal & Interest
                        </div>
                        <div className="text-sm font-bold text-right">
                          ${formatWithCommas(Math.round(monthlyPayment))}
                        </div>
                      </div>
                      {showMortgageInsurance && (
                        <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                          <div className="font-normal">
                            <span
                              className="colored_circle"
                              style={{ backgroundColor: "#DB9247" }}
                            />{" "}
                            Mortgage Insurance
                          </div>
                          <div className="text-sm font-bold text-right">
                            ${formatWithCommas(Math.round(mortgageInsurance))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <h4 className="mb-4 text-xl font-bold blueColor">
                    Mortgage details
                  </h4>
                  <div className="grid gap-12 mb-6 md:grid-cols-2">
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Home Price</div>
                      <div className="text-sm font-bold text-right">
                        ${formatWithCommas(Math.round(propertyVal))}
                      </div>
                    </div>
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Interest Rate</div>
                      <div className="text-sm font-bold text-right">
                        {interestRate}%
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-12 mb-6 md:grid-cols-2">
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Down Payment</div>
                      <div className="text-sm font-bold text-right">
                        ${formatWithCommas(Math.round(downPayment))} (
                        {downInterest}%)
                      </div>
                    </div>
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Mortgage Term</div>
                      <div className="text-sm font-bold text-right">
                        {mortgageTerm} Years
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-12 mb-6 md:grid-cols-2">
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Total Loan Cost</div>
                      <div className="text-sm font-bold text-right">
                        $
                        {formatWithCommas(
                          Math.round(
                            (monthlyPayment + mortgageInsurance) *
                              (amortization * paymentFreq)
                          )
                        )}
                      </div>
                    </div>
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Amortization Period</div>
                      <div className="text-sm font-bold text-right">
                        {amortization} Years
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-12 mb-6 md:grid-cols-2">
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Loan Amount</div>
                      <div className="text-sm font-bold text-right">
                        ${formatWithCommas(Math.round(loanAmount))}
                      </div>
                    </div>
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Payment Frequency</div>
                      <div className="text-sm font-bold text-right">
                        {paymentFreqOption}
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-12 mb-6 md:grid-cols-2">
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">Total Interest Cost</div>
                      <div className="text-sm font-bold text-right">
                        $
                        {formatWithCommas(
                          Math.round(
                            (monthlyPayment + mortgageInsurance) *
                              (amortization * paymentFreq) -
                              loanAmount
                          )
                        )}
                      </div>
                    </div>
                    <div className="grid gap-5 md:grid-cols-2 border-b pb-3">
                      <div className="font-normal">No. of Payments</div>
                      <div className="text-sm font-bold text-right">
                        {amortization * paymentFreq}
                      </div>
                    </div>
                  </div>
                  {/* Start Payment Breakdown table */}
                  <PaymentBreakdown
                    text=""
                    amortization={amortization}
                    payment={monthlyPayment + mortgageInsurance}
                    interestRate={interestRate}
                    loanAmount={loanAmount}
                    term={mortgageTerm}
                    payFreq={paymentFreq}
                  />
                </div>
                {/* <button className="py-2 text-white bg-orange-500 rounded-full px-4 text-base font-medium  w-1/2" onClick={generatePDF}>Download as PDF</button> */}
              </>
            ) : (
              <>
                <div
                  className="p-5 text-left bg-white col-start-2 col-end-4"
                  ref={pdfRef}
                >
                  <div id="toggleDiv">
                    <h1 className="mb-12 text-4xl font-bold blueColor">
                      Mortgage Summary
                    </h1>
                    <div className="grid mb-4 md:grid-cols-1">
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3">
                        <div className="exclude">
                          <h5 className="mb-1 text-xl font-bold font-bold blueColor">
                            Estimated Payment
                          </h5>
                          <p className="mb-6 text-sm font-light">
                            The following items show your expected payment
                            schedule over the full amortization period.
                          </p>
                        </div>
                        <div className="text-sm font-bold text-center ml-6">
                          <PieChart
                            piedata={[
                              {
                                label: "Principal & Interest",
                                value: Math.round(monthlyPayment),
                                color: "#264283",
                              },
                              {
                                label: "Mortgage Insurance",
                                value: Math.round(mortgageInsurance),
                                color: "#DB9247",
                              },
                            ]}
                          />
                        </div>
                        <div className="text-sm font-bold text-center ml-6">
                          <PieChart
                            piedata={[
                              {
                                label: "Principal & Interest",
                                value: Math.round(tab2MonthlyPayment),
                                color: "#264283",
                              },
                              {
                                label: "Mortgage Insurance",
                                value: Math.round(tab2MortgageInsurance),
                                color: "#DB9247",
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3">
                        <div></div>
                        <div className="text-sm font-bold  text-center">
                          <p className="mb-2 text-sm font-light font-bold font-normal blueColor">
                            Option 1
                          </p>
                          <h5 className="mb-1 text-4xl font-bold blueColor">
                            {"$" +
                              formatWithCommas(
                                Math.round(monthlyPayment + mortgageInsurance)
                              )}
                          </h5>
                          <p className="mb-6 text-sm font-light font-normal">
                            {paymentFreqOption} Payment
                          </p>
                        </div>
                        <div className="text-sm font-bold  text-center">
                          <p className="mb-2 text-sm font-light font-bold blueColor font-normal">
                            Option 2
                          </p>
                          <h5 className="mb-1 text-4xl font-bold blueColor">
                            {"$" +
                              formatWithCommas(
                                Math.round(
                                  tab2MonthlyPayment + tab2MortgageInsurance
                                )
                              )}
                          </h5>
                          <p className="mb-6 text-sm font-light font-normal">
                            {tab2PaymentFreqOption} Payment
                          </p>
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          <span
                            className="colored_circle"
                            style={{ backgroundColor: "#264283" }}
                          ></span>{" "}
                          Principal & Interest
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(monthlyPayment))}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(tab2MonthlyPayment))}
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          <span
                            className="colored_circle"
                            style={{ backgroundColor: "#DB9247" }}
                          ></span>{" "}
                          Mortgage Insurance
                        </div>
                        <div className="text-sm font-bold text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(mortgageInsurance))}
                        </div>
                        <div className="text-sm font-bold text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(tab2MortgageInsurance))}
                        </div>
                      </div>
                    </div>
                    <div className="grid mb-0 md:grid-cols-1">
                      <div className="grid gap-5 md:grid-cols-3 border-b pb-3">
                        <div className="font-normal">
                          <h4 className="mb-0 text-xl font-bold blueColor">
                            Mortgage details
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="grid mb-4 md:grid-cols-1">
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">Home Price</div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(propertyVal))}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(tab2PropertyVal))}
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Down Payment
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(downPayment))} (
                          {downInterest}%)
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(tab2DownPayment))} (
                          {tab2DownInterest}%)
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Total Loan Cost
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          $
                          {formatWithCommas(
                            Math.round(
                              (monthlyPayment + mortgageInsurance) *
                                (amortization * paymentFreq)
                            )
                          )}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          $
                          {formatWithCommas(
                            Math.round(
                              (tab2MonthlyPayment + tab2MortgageInsurance) *
                                (tab2Amortization * tab2PaymentFreq)
                            )
                          )}
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">Loan Amount</div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(loanAmount))}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          ${formatWithCommas(Math.round(tab2LoanAmount))}
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Total Interest Cost
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          $
                          {formatWithCommas(
                            Math.round(
                              (monthlyPayment + mortgageInsurance) *
                                (amortization * paymentFreq) -
                                loanAmount
                            )
                          )}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          $
                          {formatWithCommas(
                            Math.round(
                              (tab2MonthlyPayment + tab2MortgageInsurance) *
                                (tab2Amortization * tab2PaymentFreq) -
                                tab2LoanAmount
                            )
                          )}
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Interest Rate
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {interestRate}%
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {tab2InterestRate}%
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Mortgage Term
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {mortgageTerm} Years
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {tab2MortgageTerm} Years
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Amortization Period
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {amortization} Years
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {tab2Amortization} Years
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          Payment Frequency
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {paymentFreqOption}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {tab2PaymentFreqOption}
                        </div>
                      </div>
                      <div className="grid gap-5 md:grid-cols-3 grid-cols-3 border-b">
                        <div className="pt-2 pb-2 font-normal">
                          No. of Payments
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {amortization * paymentFreq}
                        </div>
                        <div className="text-sm font-bold  text-center pt-2 pb-2">
                          {tab2Amortization * tab2PaymentFreq}
                        </div>
                      </div>
                    </div>
                  </div>
                  {activeTab === "tab1" && (
                    <>
                      <PaymentBreakdown
                        text="Option 1"
                        amortization={amortization}
                        payment={monthlyPayment + mortgageInsurance}
                        interestRate={interestRate}
                        loanAmount={loanAmount}
                        term={mortgageTerm}
                        payFreq={paymentFreq}
                      />
                    </>
                  )}

                  {activeTab === "tab2" && (
                    <>
                      <PaymentBreakdown
                        text="Option 2"
                        amortization={tab2Amortization}
                        payment={tab2MonthlyPayment + tab2MortgageInsurance}
                        interestRate={tab2InterestRate}
                        loanAmount={tab2LoanAmount}
                        term={tab2MortgageTerm}
                        payFreq={tab2PaymentFreq}
                      />
                    </>
                  )}
                </div>
                {/* <button className="py-2 text-white bg-orange-500 rounded-full px-4 text-base font-medium  w-1/2" onClick={generatePDF}>Download as PDF</button> */}
              </>
            )}
          </div>
        </div>
      </section>
      <Box className="w-full ">
        <div
          className="ratehub-calc small"
          data-widget="calc-payment"
          data-lang="en"
        />
        <Box className="mt-4">
          <PortableText components={serializers} value={content} />
        </Box>
      </Box>
    </Container>
  );
};

export default SectionCalculator;
